import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MonitoringAlertsComponent } from './monitoring-alerts.component';
import { NgModule } from '@angular/core';
import { UserInfoModule } from '@caslink/common-client/ng-app/userInfo/user-info.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatPaginatorModule,
        UserInfoModule,
    ],
    declarations: [
        MonitoringAlertsComponent,
    ],
    exports: [
        MonitoringAlertsComponent,
    ],
})
export class MonitoringAlertsModule {}
